import React, { useState, useEffect } from 'react';
import { Youtube, Mail, Instagram, Facebook, Github, Cake, MapPin, Briefcase, Star, Coffee, Moon, Sun, Bot, Globe, Code } from 'lucide-react';

const AgeCalculator = ({ birthDate, isDark }) => {
  const [age, setAge] = useState(0);

  useEffect(() => {
    const calculateAge = (birthDateString) => {
      const today = new Date();
      const birthDate = new Date(birthDateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      // Adjust age if the birthday hasn't occurred yet this year
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age;
    };

    setAge(calculateAge(birthDate));
  }, [birthDate]);

  return (
    <span className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
      {age} years old
    </span>
  );
};

const AnimeProfile = () => {
  const getWindowsTheme = () => {
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDarkMode ? true : false;
  };

  const [isDark, setIsDark] = useState(getWindowsTheme());

  const toggleTheme = () => {
    setIsDark(!isDark);
    document.documentElement.classList.toggle('dark');
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? 'bg-gray-900' : 'bg-pink-50'} pb-12`}>
      {/* Theme Toggle */}
      <button
        onClick={toggleTheme}
        className="fixed top-4 right-4 p-2 rounded-full bg-opacity-80 backdrop-blur-sm transition-colors duration-300
          dark:bg-gray-800 bg-white shadow-lg"
      >
        {isDark ? (
          <Sun className="w-6 h-6 text-yellow-400" />
        ) : (
          <Moon className="w-6 h-6 text-gray-600" />
        )}
      </button>

      <div className="max-w-3xl mx-auto p-6">
        {/* Profile Card */}
        <div className={`rounded-3xl shadow-lg overflow-hidden mt-10 transition-colors duration-300 
          ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
          {/* Banner */}
          <div className="h-32 bg-gradient-to-r from-pink-400 to-pink-300">
            <img src="/Gdi0MYIXMAATkeh.jpg"
              alt="Banner"
              className="w-full h-full object-cover">
            </img>
          </div>

          {/* Profile Content */}
          <div className="relative px-6 pb-6">
            {/* Avatar */}
            <div className="absolute -top-16 left-1/2 transform -translate-x-1/2">
              <div className="w-32 h-32 rounded-full border-4 border-white dark:border-gray-800 shadow-lg bg-pink-100 flex items-center justify-center overflow-hidden">
                <img
                  src="/teeratat.jpg"
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>


            {/* Profile Info */}
            <div className="pt-16 mt-20 text-center">
              <h1 className={`text-2xl font-bold transition-colors duration-300 
                ${isDark ? 'text-white' : 'text-gray-800'}`}>Teeratat Nakarin</h1>
              <p className="text-pink-500 font-medium mt-1">Programmer & Content Creater</p>

              {/* Personal Details */}
              <div className="mt-4 flex flex-wrap justify-center gap-4 text-gray-600 dark:text-gray-300">
                <div className="flex items-center gap-1">
                  <Cake className="w-4 h-4 text-pink-400" />
                  <AgeCalculator birthDate="2005-07-09" isDark={isDark} />
                </div>
                <div className="flex items-center gap-1">
                  <MapPin className="w-4 h-4 text-pink-400" />
                  <span className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Phuket, Thailand</span>
                </div>
                <div className="flex items-center gap-1">
                  <Briefcase className="w-4 h-4 text-pink-400" />
                  <span className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Bachelor's degree, Student</span>
                </div>
              </div>

              {/* Bio */}
              <p className={`mt-4 transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                สวัสดีครับ ขอบคุณที่เข้ามาเยี่ยมชมเว็บของผมนะครับ ข้อมูลต่างๆภายในเว็บนี้จะเป็นข้อมูลที่ผมเคยทำไว้ และเป็นการเก็บ Portfolio ของผมนะครับ :)
              </p>

              {/* Stats */}
              <div className="flex justify-center gap-6 mt-6">
                <div className="text-center">
                  <div className={`text-xl font-bold transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>10+</div>
                  <div className={`text-sm transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Projects</div>
                </div>
                <div className="text-center">
                  <div className={`text-xl font-bold transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>110k+</div>
                  <div className={`text-sm transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Servers</div>
                </div>
                <div className="text-center">
                  <div className={`text-xl font-bold transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>5.7M+</div>
                  <div className={`text-sm transition-colors duration-300 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Users</div>
                </div>
              </div>

              {/* Social Links */}
              <div className="flex justify-center gap-4 mt-6">
                <button onClick={() => window.location.href = "mailto:mikihinasann@gmail.com"} className={`p-2 rounded-full text-pink-400 hover:bg-pink-200 transition-colors ${isDark ? 'bg-pink-200' : 'bg-pink-700'}`}>
                  <Mail size={20} />
                </button>
                <button onClick={() => window.location.href = "https://www.instagram.com/mikihina.btr/"} className={`p-2 rounded-full text-pink-400 hover:bg-pink-200 transition-colors ${isDark ? 'bg-pink-200' : 'bg-pink-700'}`}>
                  <Instagram size={20} />
                </button>
                <button onClick={() => window.location.href = "https://www.facebook.com/teeratat.nakarin"} className={`p-2 rounded-full text-pink-400 hover:bg-pink-200 transition-colors ${isDark ? 'bg-pink-200' : 'bg-pink-700'}`}>
                  <Facebook size={20} />
                </button>
                <button onClick={() => window.location.href = "https://www.youtube.com/@mikihinasann"} className={`p-2 rounded-full text-pink-400 hover:bg-pink-200 transition-colors ${isDark ? 'bg-pink-200' : 'bg-pink-700'}`}>
                  <Youtube size={20} />
                </button>
                <button onClick={() => window.location.href = "https://github.com/MikihinaSann"} className={`p-2 rounded-full text-pink-400 hover:bg-pink-200 transition-colors ${isDark ? 'bg-pink-200' : 'bg-pink-700'}`}>
                  <Github size={20} />
                </button>
              </div>

              {/* Follow Button */}
              <button className="mt-6 w-full bg-pink-500 text-white py-2 rounded-xl hover:bg-pink-600 transition-colors font-medium">
                Follow Me
              </button>
            </div>
          </div>
        </div>

        {/* Additional Info Cards */}
        <div className="grid md:grid-cols-2 gap-6 mt-6">
          {/* About Me Card */}
          <div className={`rounded-2xl shadow-lg p-6 transition-colors duration-300 
            ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
            <h2 className={`text-xl font-bold mb-4 flex items-center gap-2 transition-colors duration-300 
              ${isDark ? 'text-white' : 'text-gray-800'}`}>
              <Star className="text-pink-400" /> About Me
            </h2>
            <div className="space-y-3 transition-colors duration-300 dark:text-gray-300 text-gray-600">
              <p className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}><span className={`transition-colors font-medium duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Full Name:</span> Teeratat Nakarin</p>
              <p className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}><span className={`transition-colors font-medium duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Birthday:</span> July 9, 2005</p>
              <p className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}><span className={`transition-colors font-medium duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Languages:</span> JavaScript, Python, TypeScript, lua</p>
              <p className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}><span className={`transition-colors font-medium duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Education:</span> Artificial Intelligence and System Engineering (AISE)</p>
              <p className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}><span className={`transition-colors font-medium duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Specialties:</span> Discord Bots, Web Development, Minecraft Script</p>
              <p className={`transition-colors duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}><span className={`transition-colors font-medium duration-300
            ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>Hobbies:</span> Coding, Gaming, Playing guitar</p>
            </div>
          </div>

          {/* Mixed Projects Card */}
          <div className={`rounded-2xl shadow-lg p-6 transition-colors duration-300 
            ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
            <h2 className={`text-xl font-bold mb-4 flex items-center gap-2 transition-colors duration-300 
              ${isDark ? 'text-white' : 'text-gray-800'}`}>
              <Coffee className="text-pink-400" /> Featured Projects
            </h2>
            <div className="space-y-4">
              <div className="border-b border-pink-100 dark:border-pink-900 pb-3">
                <div className="flex items-center gap-2">
                  <Bot className="w-4 h-4 text-pink-400" />
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>Profile Infomation</h3>
                </div>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  เว็บไซต์ Portfolio ที่ไว้รวบข้อมูลที่เคยทำ
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>React</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Tailwind</span>
                </div>
              </div>

              <div className="border-b border-pink-100 dark:border-pink-900 pb-3">
                <div className="flex items-center gap-2">
                  <Globe className="w-4 h-4 text-pink-400" />
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>MaFiaWorLD BOT</h3>
                </div>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  Assistant ประจำดิสคอร์ดที่ทุกๆคนควรมี
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>200+ Servers</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Node.js</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>MySQL</span>
                </div>
              </div>

              <div className="pb-3">
                <div className="flex items-center gap-2">
                  <Code className="w-4 h-4 text-pink-400" />
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>API-Validate</h3>
                </div>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  API ยืนยันตัวตน Minecraft Instance
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Node.js</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Fastify</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>MySQL</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`mt-6 rounded-2xl shadow-lg p-6 transition-colors duration-300 
          ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
          <h2 className={`text-xl font-bold mb-4 flex items-center gap-2 transition-colors duration-300 
            ${isDark ? 'text-white' : 'text-gray-800'}`}>
            <Bot className="text-pink-400" /> My Discord Bots
          </h2>
          <div className="grid md:grid-cols-2 gap-4">
            {/* Bot Cards */}
            <div className={`p-4 rounded-xl transition-colors duration-300 
              ${isDark ? 'bg-gray-700' : 'bg-pink-50'}`}>
              <div className="flex items-start gap-3">
                <div className={`w-[4.25rem] h-10 rounded-full flex items-center justify-center ${isDark ? 'bg-pink-200' : 'bg-pink-900'}`}>
                  <Bot className="w-6 h-5 justify-center text-pink-500" />
                </div>
                <div>
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>BloodRose</h3>
                  <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                    บอทที่ไว้ใช้สำหรับคุยแชทเล่น และยังมีระบบความรู้สึกต่อคำพูดนั้นๆอีกด้วย!
                  </p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      92k+ servers
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      24/7 online
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      ChatBot
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`p-4 rounded-xl transition-colors duration-300 
              ${isDark ? 'bg-gray-700' : 'bg-pink-50'}`}>
              <div className="flex items-start gap-3">
                <div className={`w-[3.75rem] h-10 rounded-full flex items-center justify-center ${isDark ? 'bg-pink-200' : 'bg-pink-900'}`}>
                  <Bot className="w-6 h-5 justify-center text-pink-500" />
                </div>
                <div>
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>ElainaSann</h3>
                  <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                    บอท Discord มินิเกม MMORPG คล้าย RO ที่มีระบบแชทบอท!
                  </p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      20k+ servers
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      MMORPG
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      ChatBot
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`p-4 rounded-xl transition-colors duration-300 
              ${isDark ? 'bg-gray-700' : 'bg-pink-50'}`}>
              <div className="flex items-start gap-3">
                <div className={`w-14 h-10 rounded-full flex items-center justify-center ${isDark ? 'bg-pink-200' : 'bg-pink-900'}`}>
                  <Bot className="w-6 h-5 justify-center text-pink-500" />
                </div>
                <div>
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>BocchiSann (Beta Test)</h3>
                  <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                    บอทตัวนี้ไว้ใช้ในการทดสอบ ก่อนนำโค้ดลงไปใช้ในบอทหลัก
                  </p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      370+ servers
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      MMORPG
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      ChatBot
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className={`p-4 rounded-xl transition-colors duration-300 
              ${isDark ? 'bg-gray-700' : 'bg-pink-50'}`}>
              <div className="flex items-start gap-3">
                <div className={`w-24 h-10 rounded-full flex items-center justify-center ${isDark ? 'bg-pink-200' : 'bg-pink-900'}`}>
                  <Bot className="w-6 h-5 justify-center text-pink-500" />
                </div>
                <div>
                  <h3 className={`font-medium transition-colors duration-300 
                    ${isDark ? 'text-white' : 'text-gray-800'}`}>YunaSann</h3>
                  <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                    บอทยืนยันตัวตน และรักษาความปลอดภัยพร้อมระบบ ตรวจจับลิ้งค์อันตรายที่สามารถเลือกหมวดหมู่ได้!
                  </p>
                  <div className="flex items-center gap-2 mt-2">
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      600+ servers
                    </span>
                    <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>
                      Antilink
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 gap-6 mt-6">
          {/* Websites Projects */}
          <div className={`rounded-2xl shadow-lg p-6 transition-colors duration-300 
            ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
            <h2 className={`text-xl font-bold mb-4 flex items-center gap-2 transition-colors duration-300 
              ${isDark ? 'text-white' : 'text-gray-800'}`}>
              <Globe className="text-pink-400" /> Web Projects
            </h2>
            <div className="space-y-4">
              <div className="border-b border-pink-100 dark:border-pink-900 pb-3">
                <h3 className={`font-medium transition-colors duration-300 
                  ${isDark ? 'text-white' : 'text-gray-800'}`}>Profile Infomation</h3>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  Portfolio website showcasing my projects and skills
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>React</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Node.js</span>
                </div>
              </div>

              {/* <div className="border-b border-pink-100 dark:border-pink-900 pb-3">
                <h3 className={`font-medium transition-colors duration-300 
                  ${isDark ? 'text-white' : 'text-gray-800'}`}>Bot Dashboard</h3>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  Admin dashboard for managing Discord bots
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Next.js</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Tailwind</span>
                </div>
              </div> */}
            </div>
          </div>

          {/* Coding Projects */}
          <div className={`rounded-2xl shadow-lg p-6 transition-colors duration-300 
            ${isDark ? 'bg-gray-800' : 'bg-white'}`}>
            <h2 className={`text-xl font-bold mb-4 flex items-center gap-2 transition-colors duration-300 
              ${isDark ? 'text-white' : 'text-gray-800'}`}>
              <Code className="text-pink-400" /> Development
            </h2>
            <div className="space-y-4">
              <div className="border-b border-pink-100 dark:border-pink-900 pb-3">
                <h3 className={`font-medium transition-colors duration-300 
                  ${isDark ? 'text-white' : 'text-gray-800'}`}>BR-NLP (ReWrite With NLP.js)</h3>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  Module ที่สร้างขึ้นเพื่อใช้ในการตรวจสอบคำพูด และตรวจจับหมวดหมู่ของคำพูดและประโยคนั้นๆ
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>TypeScript</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>NLP.js</span>
                </div>
              </div>

              <div className="pb-3">
                <h3 className={`font-medium transition-colors duration-300 
                  ${isDark ? 'text-white' : 'text-gray-800'}`}>API-Validate</h3>
                <p className={`text-sm transition-colors duration-300 mt-1 ${isDark ? 'text-gray-300' : 'text-gray-500'}`}>
                  API ยืนยันตัวตน Minecraft Instance สำหรับ MagicLab
                </p>
                <div className="flex gap-2 mt-2">
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Fastify</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>MySQL</span>
                  <span className={`text-xs text-pink-400 px-2 py-1 rounded-full ${isDark ? 'bg-pink-100' : 'bg-pink-900'}`}>Node.js</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimeProfile;